export default __webpack_public_path__ + "static/media/banner3.71469db7.jpg";